import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { connect } from 'react-redux';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { getResultData, getApiDataRequest, performApiRequest } from '../redux/apiData';
import ErrorBlock from './ErrorBlock';
import { getErrorBlockProps } from '../constants/errorMessages';
import withMatch from '@/hocs/withMatch';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
    projectSlug = _ownProps$match$param.projectSlug,
    env = _ownProps$match$param.env;
  return {
    settings: getResultData(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }),
    request: getApiDataRequest(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getNewSettings: function getNewSettings() {
      var _ownProps$match$param2 = ownProps.match.params,
        projectSlug = _ownProps$match$param2.projectSlug,
        env = _ownProps$match$param2.env;
      dispatch(performApiRequest('getSettings', {
        projectSlug: String(projectSlug),
        env: String(env)
      }));
    }
  };
};
export default (function (WrappedComponent) {
  var WithSettings = /*#__PURE__*/function (_React$Component) {
    function WithSettings() {
      var _this;
      _classCallCheck(this, WithSettings);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, WithSettings, [].concat(args));
      _defineProperty(_this, "state", {
        renderWidth: 1200
      });
      _defineProperty(_this, "onResize", function () {
        _this.setState({
          renderWidth: _this.getLayoutWidth()
        });
      });
      return _this;
    }
    _inherits(WithSettings, _React$Component);
    return _createClass(WithSettings, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.loadSettings({
          match: {
            params: {
              projectSlug: '',
              env: ''
            }
          }
        });
        window.addEventListener('resize', this.onResize);
        this.onResize();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(oldProps) {
        this.loadSettings(oldProps);
      }
    }, {
      key: "getLayoutWidth",
      value: function getLayoutWidth() {
        return document.body && document.body.offsetWidth || 0;
      }
    }, {
      key: "loadSettings",
      value: function loadSettings(oldProps) {
        var _this$props = this.props,
          request = _this$props.request,
          getNewSettings = _this$props.getNewSettings;
        var _oldProps$match$param = oldProps.match.params,
          oldProjectSlug = _oldProps$match$param.projectSlug,
          oldEnv = _oldProps$match$param.env;
        var _this$props$match$par = this.props.match.params,
          newProjectSlug = _this$props$match$par.projectSlug,
          newEnv = _this$props$match$par.env;
        if (oldProjectSlug !== newProjectSlug || oldEnv !== newEnv || !request || request && request.networkStatus === 'ready') {
          getNewSettings();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          settings = _this$props2.settings,
          request = _this$props2.request,
          match = _this$props2.match;
        var renderWidth = this.state.renderWidth;
        if (request && request.networkStatus === 'failed' && request.errorBody && request.errorBody.name && request.errorBody.name !== 'FetchError') {
          return __jsx(ErrorBlock, _extends({}, getErrorBlockProps(match, 'settings', 4044), {
            fullscreen: true,
            "data-id": "components_WithSettings_ErrorBlock"
          }));
        }
        return __jsx(WrappedComponent, {
          settings: settings,
          settingsRequest: request,
          match: match,
          renderWidth: renderWidth,
          "data-id": "components_WithSettings_WrappedComponent"
        });
      }
    }]);
  }(React.Component);
  _defineProperty(WithSettings, "displayName", "WithSettings(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")"));
  hoistNonReactStatic(WithSettings, WrappedComponent);

  // prettier-ignore
  // $FlowFixMe
  return withMatch(connect(mapStateToProps, mapDispatchToProps)(WithSettings));
});